import { IImportHandler } from '../import-handler.interface';
import { WorkspaceDataImporterService } from '@database/workspace';
import { ErrorCodes, FileModel } from '@shared';
import { LoggingService } from '@shared/logging';
import { WorkspaceRepository } from '@database/central';

export class WorkspaceDataImportHandler implements IImportHandler {
	private next: IImportHandler;

	public constructor(
		private workspaceDataImporterService: WorkspaceDataImporterService,
		private loggingService: LoggingService,
		private workspaceRepository: WorkspaceRepository
	) {}

	public async cleanup(model: FileModel): Promise<void> {
		await this.workspaceRepository.remove(model.workFileId);
	}

	public setNext(nextHandler: IImportHandler) {
		this.next = nextHandler;
	}

	public async handle(model: FileModel) {
		try {
			await this.workspaceDataImporterService.importData(model.TABLE_DATA, model.workFileId);
		} catch (error) {
			this.loggingService.error(ErrorCodes.WorkspaceDataImportHandler, error);
			await this.cleanup(model);
			throw error;
		}

		if (this.next) {
			await this.next.handle(model);
		}
	}
}
